import { Component, ChangeDetectionStrategy, Input, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'tidy-ai-image',
  templateUrl: './ai-image.component.html',
  styleUrls: ['./ai-image.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiImageComponent implements OnInit {
  @Input() type: 'thinking' | 'waiting' | 'failed' | 'bid' | 'accepted' | 'canceled' = 'thinking';
  @Input() size = 20;
  @Input() paused = false;

  @HostBinding('class.ai-paused') get isPaused() { return this.paused; }

  color = '#00AABA';
  animationDelay = '0s';
  orbitDelay = '0s';
  pulseDelay = '0s';

  ngOnInit() {
    if (this.type === 'failed' || this.type === 'canceled') {
      this.color = '#FF6C78';
    } else if (this.type === 'bid' || this.type === 'accepted') {
      this.color = '#4295A3';
    }
    const now = Date.now();
    this.animationDelay = `-${now % 8000}ms`;
    this.orbitDelay = `-${now % 4000}ms`;
    this.pulseDelay = `-${now % 2500}ms`;
  }
}
